export class ListStorageGatewaysResponse {
    'storageGateways';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageGateways",
            "baseName": "StorageGateways",
            "type": "Array<StorageGateway>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListStorageGatewaysResponse.attributeTypeMap;
    }
    constructor() {
    }
}
